import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "deleted-orders-container" };
const _hoisted_2 = { class: "row mb-25 g-3" };
const _hoisted_3 = { class: "col-md-4 text-md-end" };
const _hoisted_4 = { class: "kpi-mini bg-light p-15 rounded shadow-sm d-inline-block text-start" };
const _hoisted_5 = { class: "fw-bold mb-0 text-danger" };
const _hoisted_6 = { class: "card border-0 shadow-sm mb-25 p-20" };
const _hoisted_7 = { class: "row g-3 align-items-end" };
const _hoisted_8 = { class: "col-md-4" };
const _hoisted_9 = ["value"];
const _hoisted_10 = { class: "col-md-8 text-md-end" };
const _hoisted_11 = { class: "card border-0 shadow-sm" };
const _hoisted_12 = { class: "table-responsive" };
const _hoisted_13 = { class: "table table-hover align-middle mb-0" };
const _hoisted_14 = { key: 0 };
const _hoisted_15 = { key: 1 };
const _hoisted_16 = { class: "ps-20 py-15" };
const _hoisted_17 = { class: "fw-bold d-block" };
const _hoisted_18 = { class: "text-muted extremely-small" };
const _hoisted_19 = { class: "badge bg-light text-dark fw-medium" };
const _hoisted_20 = { class: "small d-block" };
const _hoisted_21 = { style: { "max-width": "250px" } };
const _hoisted_22 = ["title"];
const _hoisted_23 = { class: "fw-bold" };
const _hoisted_24 = { class: "pe-20 text-end" };
const _hoisted_25 = { class: "d-flex justify-content-end gap-2" };
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
    key: 0,
    class: "card-footer bg-white border-0 py-15"
};
const _hoisted_29 = { "aria-label": "Page navigation" };
const _hoisted_30 = { class: "pagination pagination-sm justify-content-center mb-0" };
const _hoisted_31 = ["onClick"];
const _hoisted_32 = { key: 0 };
const _hoisted_33 = { class: "text-center py-3" };
const _hoisted_34 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-md-8" }, [
                _createElementVNode("h4", { class: "fw-bold mb-1" }, "Commandes Supprimées"),
                _createElementVNode("p", { class: "text-muted small mb-0" }, " Gérez l'historique des commandes supprimées par les restaurants. Restaurez-les ou supprimez-les définitivement. ")
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-muted small d-block mb-1" }, "Total en attente", -1)),
                    _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.totalDeleted), 1)
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label small fw-bold text-muted mb-1" }, "Filtrer par Restaurant", -1)),
                    _withDirectives(_createElementVNode("select", {
                        class: "form-select form-select-sm",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.filterRestaurant) = $event)),
                        onChange: _cache[1] || (_cache[1] = ($event) => (_ctx.fetchDeletedOrders(1)))
                    }, [
                        _cache[9] || (_cache[9] = _createElementVNode("option", { value: "all" }, "Tous les restaurants", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restaurants, (res) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: res.id,
                                value: res.id
                            }, _toDisplayString(res.name), 9, _hoisted_9));
                        }), 128))
                    ], 544), [
                        [_vModelSelect, _ctx.filterRestaurant]
                    ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                        class: "btn btn-outline-secondary btn-sm",
                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.fetchDeletedOrders(1)))
                    }, [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("i", { class: "ph-bold ph-arrows-clockwise me-1" }, null, -1),
                            _createTextVNode(" Actualiser ", -1)
                        ]))])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
                _createElementVNode("table", _hoisted_13, [
                    _cache[16] || (_cache[16] = _createElementVNode("thead", { class: "bg-light" }, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", { class: "ps-20 py-15 border-0 small text-uppercase fw-bold text-muted" }, "NIF / ID"),
                            _createElementVNode("th", { class: "py-15 border-0 small text-uppercase fw-bold text-muted" }, "Restaurant"),
                            _createElementVNode("th", { class: "py-15 border-0 small text-uppercase fw-bold text-muted" }, "Date Suppression"),
                            _createElementVNode("th", { class: "py-15 border-0 small text-uppercase fw-bold text-muted" }, "Justification"),
                            _createElementVNode("th", { class: "py-15 border-0 small text-uppercase fw-bold text-muted" }, "Montant"),
                            _createElementVNode("th", { class: "pe-20 py-15 border-0 small text-uppercase fw-bold text-muted text-end" }, "Actions")
                        ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                        (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [...(_cache[12] || (_cache[12] = [
                                    _createElementVNode("td", {
                                        colspan: "6",
                                        class: "text-center py-50"
                                    }, [
                                        _createElementVNode("div", {
                                            class: "spinner-border text-primary",
                                            role: "status"
                                        }),
                                        _createElementVNode("p", { class: "text-muted mt-2 small" }, "Chargement des commandes supprimées...")
                                    ], -1)
                                ]))]))
                            : (_ctx.orders.length === 0)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [...(_cache[13] || (_cache[13] = [
                                        _createElementVNode("td", {
                                            colspan: "6",
                                            class: "text-center py-50"
                                        }, [
                                            _createElementVNode("i", { class: "ph-bold ph-file-x fs-40 text-muted mb-2" }),
                                            _createElementVNode("p", { class: "text-muted mb-0" }, "Aucune commande supprimée trouvée.")
                                        ], -1)
                                    ]))]))
                                : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
                            return (_openBlock(), _createElementBlock("tr", {
                                key: order.id
                            }, [
                                _createElementVNode("td", _hoisted_16, [
                                    _createElementVNode("span", _hoisted_17, "#" + _toDisplayString(order.nif), 1),
                                    _createElementVNode("span", _hoisted_18, _toDisplayString(order.id.substring(0, 8)) + "...", 1)
                                ]),
                                _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_19, _toDisplayString(order.restaurant?.name || 'Inconnu'), 1)
                                ]),
                                _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatDateTime(order.updated_at)), 1)
                                ]),
                                _createElementVNode("td", _hoisted_21, [
                                    _createElementVNode("p", {
                                        class: "mb-0 small text-truncate-2",
                                        title: order.deletion_reason
                                    }, _toDisplayString(order.deletion_reason || 'Aucune raison fournie'), 9, _hoisted_22)
                                ]),
                                _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.formatCHF(order.totalPrice)), 1)
                                ]),
                                _createElementVNode("td", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("button", {
                                            class: "btn btn-sm btn-outline-success border-0",
                                            title: "Restaurer la commande",
                                            onClick: ($event) => (_ctx.handleRestore(order))
                                        }, [...(_cache[14] || (_cache[14] = [
                                                _createElementVNode("i", { class: "ph-bold ph-arrow-counter-clockwise fs-18" }, null, -1)
                                            ]))], 8, _hoisted_26),
                                        _createElementVNode("button", {
                                            class: "btn btn-sm btn-outline-danger border-0",
                                            title: "Supprimer définitivement",
                                            onClick: ($event) => (_ctx.handlePermanentDelete(order))
                                        }, [...(_cache[15] || (_cache[15] = [
                                                _createElementVNode("i", { class: "ph-bold ph-trash fs-18" }, null, -1)
                                            ]))], 8, _hoisted_27)
                                    ])
                                ])
                            ]));
                        }), 128))
                    ])
                ])
            ]),
            (_ctx.pagination.totalPages > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("nav", _hoisted_29, [
                        _createElementVNode("ul", _hoisted_30, [
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.pagination.page === 1 }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.fetchDeletedOrders(_ctx.pagination.page - 1)), ["prevent"]))
                                }, "Précédent")
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagination.totalPages, (p) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: p,
                                    class: _normalizeClass(["page-item", { active: p === _ctx.pagination.page }])
                                }, [
                                    _createElementVNode("a", {
                                        class: "page-link",
                                        href: "#",
                                        onClick: _withModifiers(($event) => (_ctx.fetchDeletedOrders(p)), ["prevent"])
                                    }, _toDisplayString(p), 9, _hoisted_31)
                                ], 2));
                            }), 128)),
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.pagination.page === _ctx.pagination.totalPages }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.fetchDeletedOrders(_ctx.pagination.page + 1)), ["prevent"]))
                                }, "Suivant")
                            ], 2)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true)
        ]),
        _createVNode(_component_b_modal, {
            modelValue: _ctx.showRestoreModal,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.showRestoreModal) = $event)),
            title: "Confirmer la restauration",
            onOk: _ctx.confirmRestore,
            "ok-title": "Restaurer",
            "ok-variant": "success",
            "cancel-title": "Annuler"
        }, {
            default: _withCtx(() => [
                (_ctx.selectedOrder)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                        _cache[17] || (_cache[17] = _createTextVNode("Voulez-vous vraiment restaurer la commande ", -1)),
                        _createElementVNode("strong", null, "#" + _toDisplayString(_ctx.selectedOrder.nif), 1),
                        _cache[18] || (_cache[18] = _createTextVNode(" ?", -1))
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        }, 8, ["modelValue", "onOk"]),
        _createVNode(_component_b_modal, {
            modelValue: _ctx.showDeleteModal,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.showDeleteModal) = $event)),
            title: "SUPPRESSION DEFINITIVE",
            onOk: _ctx.confirmPermanentDelete,
            "ok-title": "Supprimer définitivement",
            "ok-variant": "danger",
            "cancel-title": "Annuler"
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_33, [
                    _cache[21] || (_cache[21] = _createElementVNode("i", { class: "ph-bold ph-warning-octagon text-danger fs-50 mb-3" }, null, -1)),
                    _cache[22] || (_cache[22] = _createElementVNode("h5", { class: "text-danger fw-bold" }, "ATTENTION : ACTION IRREVERSIBLE", -1)),
                    (_ctx.selectedOrder)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                            _cache[19] || (_cache[19] = _createTextVNode("Vous allez supprimer définitivement la commande ", -1)),
                            _createElementVNode("strong", null, "#" + _toDisplayString(_ctx.selectedOrder.nif), 1),
                            _cache[20] || (_cache[20] = _createTextVNode(". Cette commande ne pourra plus jamais être restaurée.", -1))
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            _: 1
        }, 8, ["modelValue", "onOk"])
    ]));
}
